import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../_services/app.service';
import { DecryptPipe } from '../../auth/_services/encrypt-decrypt.pipe';
import { CommonService } from '../../shared/services/commen/commen.services';
import { OrdersService } from '../../shared/services/orders/orders.service';
import { TranslateConfigService } from '../../theme/home/translateConfig.service';
import { DatePipe } from '@angular/common';
// Added by priya - 19/01/2026 - Importing ulip service for using common function - cn(PRIYA-JAN26-013)
import { UlipService } from '../../../app/shared/services/Ulip/ulip.service';
import { NewUlipComponent } from '../../../app/shared/components/new-ulip/new-ulip.component';

@Component({
  selector: 'app-shipnow-vehicle-assign',
  templateUrl: './shipnow-vehicle-assign.component.html',
  styleUrls: ['./shipnow-vehicle-assign.component.scss']
})
export class ShipnowVehicleAssignComponent implements OnInit, OnChanges {

  @Output() onCloseEvent = new EventEmitter<any>();
  isFormSubmit: boolean = false;
  TenantId: any;
  CompanyId: any;
  userId: any;
  data: any = {};
  @Input() bookingData: any;
  @Input() IsSaveDisable: any = false;
  @Output() onSave = new EventEmitter<any>();
  @ViewChild("ValidateUlip") ValidateUlip: TemplateRef<any>;
  modalRef: NgbModalRef | null = null;
  enableUlipForVehicle: boolean = false;
  enableUlipForDriver: boolean = false;
  vahanData: any;
  isVehValid: boolean = false;
  IsVarifiedUlip: boolean = false;
  TransportService: any = {
    lable: 'Transport Service',
    formControlName: 'TransportService',
    dataField: 'TransportService',
    isRequired: true,
    placeholder: 'Select Transport Service',
    typeOfField: 'dropdown',
    isValueBind: true
  };
  Transporter: any = {
    lable: 'Transporter',
    formControlName: 'Transporter',
    dataField: 'Transporter',
    isRequired: true,
    placeholder: 'Select Transporter',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  VehicleType: any = {
    lable: 'Vehicle Type',
    formControlName: 'VehicleType',
    dataField: 'VehicleType',
    isRequired: true,
    placeholder: 'Select Vehicle Type',
    typeOfField: 'dropdown',
    isValueBind: true,
    isSearchByApi: true,
  };
  VehicleNo: any = {
    lable: 'Vehicle No',
    formControlName: 'VehicleNo',
    dataField: 'VehicleNo',
    isRequired: true,
    placeholder: 'Select Vehicle No',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true,
    addTag: false,
  };
  Driver: any = {
    lable: 'Driver',
    formControlName: 'Driver',
    dataField: 'Driver',
    isRequired: true,
    placeholder: 'Select Driver',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true,
    addTag: false,
  };
  DriverMobileNo = {
    lable: 'Driver Mobile No',
    formControlName: 'DriverMobileNo',
    dataField: 'DriverMobileNo',
    isRequired: true,
    placeholder: 'Enter Driver Mobile No',
  };
  VehiclePlacementDate = {
    lable: 'Vehicle Placement Date',
    formControlName: 'VehiclePlacementDate',
    dataField: 'VehiclePlacementDate',
    isRequired: true,
    placeholder: 'Select Vehicle Placement Date',
    isTime: true,
  };
  LeadTime = {
    lable: 'Lead Time in Days',
    formControlName: 'LeadTime',
    dataField: 'LeadTime',
    isRequired: false,
    placeholder: 'Enter Lead Time in Days',
    type: 'number'
  };
  EstimatedDeliveryDate = {
    lable: 'Estimated Delivery Date',
    formControlName: 'EstimatedDeliveryDate',
    dataField: 'EstimatedDeliveryDate',
    isRequired: true,
    placeholder: 'Select Estimated Delivery Date',
    isTime: true,
  };
  Advance = {
    lable: 'Advance',
    formControlName: 'Advance',
    dataField: 'Advance',
    isRequired: false,
    placeholder: 'Enter Advance',
    type: 'number'
  };
  DriverLicenseNo = {
    lable: 'Driver License No',
    formControlName: 'DriverLicenseNo',
    dataField: 'DriverLicenseNo',
    isRequired: false,
    placeholder: 'Enter Driver License No',
  };
  DriverDOB = {
    lable: 'Driver DOB',
    formControlName: 'DriverDOB',
    dataField: 'DriverDOB',
    isRequired: false,
    placeholder: 'Select Driver DOB',
  };

  isMobileView: any;
  TransportersType: any;

  selectedBranchCountry: any;
  vahanDataList: any = [];
  sarathiDataList: any = [];
  sarathiData: any;
  isDriverValid: boolean = false;
  @ViewChild('ulipComp') ulipComp: NewUlipComponent;
  @Input() ScreenName: any;
  isTransportServiceDisabled: boolean = true;
  isTransporterDisabled: boolean = true;
  IsCalculateTravelTimeByVehicleKm: boolean = false; // Added by priya - 23/06/2026 - cn(PRIYA-JUN26-008)

  constructor(
    private route: ActivatedRoute,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private translate: TranslateService,
    private anghttp: Http,
    private commonService: CommonService,
    private decryptpipe: DecryptPipe,
    private service: TranslateConfigService,
    private modalService: NgbModal,
    private orderService: OrdersService,
    private router: Router,
    private dp: DatePipe,
    private Ulip: UlipService // Added by priya - 19/01/2026 - Importing ulip service for using common function - cn(PRIYA-JAN26-013)
  ) { }

  ngOnInit() {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.TenantId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).TenantId;
    this.selectedBranchCountry = ChnageCompnayId && ChnageCompnayId.Country;
    this.LoadULIPVerification(); //added by fahim 30-12-2025 :)
    this.GetsystemSettingValueForCalculateTime(); // Added by priya - 23/06/2026 - cn(PRIYA-JUN26-008)
    this.CheckSarathiLicenseValidity(); //added by fahim 30-12-2025 :)
    this.getDropdownList(null, this.TransportService);
    this.getDropdownList('%%', this.VehicleType);
    setTimeout(() => {
      this.BydeafltFTL();
    }, 500);
    this.data = this.bookingData;
    if (this.bookingData.OrderPickupDate) {
      this.data.VehiclePlacementDate = this.bookingData.OrderPickupDate || this.bookingData.VehiclePlacementDate;
      this.CalculateDeliveryDate(this.data.VehiclePlacementDate, this.data.LeadTime || 0);
    }
    if (this.bookingData.VehicleNo) {
      this.GetVehicleNoList(this.bookingData.VehicleNo, false);
    }
    if (this.bookingData.Driver !== '' || this.bookingData.Driver !== null) {
      const DriverName = decodeURIComponent(this.bookingData.DriverName); // Decode Driver
      const DriverCode = decodeURIComponent(this.bookingData.DriverCode);
      if (this.bookingData.DriverCode) {
        this.GetDriverList(this.bookingData.DriverCode, false)
      } else {
        this.GetDriverList(this.bookingData.DriverName, false)
      }
    } else {
      console.log('calling')
      this.Driver.placeholder = 'Select Driver'
    }
    console.log('details', this.data, this.bookingData)
    // this.data.Transporter = this.bookingData.Transporter.toLowerCase();
    this.data.Transporter = this.bookingData && this.bookingData.Transporter ? this.bookingData.Transporter.toLowerCase() : null;
    this.GetTransporterList(this.data.TransporterName, false);
    if (this.bookingData.FromBidding === true) {
      this.GetNewVehicle('%%');
    }

    console.log('selectedBranchCountry', this.selectedBranchCountry);
    if (this.ScreenName === 'Dispatch') {
      this.isTransportServiceDisabled = false;
      this.isTransporterDisabled = false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['ScreenName'] && this.ScreenName === 'Dispatch') {
      this.isTransportServiceDisabled = false;
      this.isTransporterDisabled = false;
      this.VehicleNo.addTag = true;
      this.Driver.addTag = true;
    }
  }

  close() {
    this.onCloseEvent.emit();
  }

  getChangedValue(value, data) {
    if (data.dataField == 'Transporter') {
      this.data[data.dataField] = value.value;
    } else if (data.dataField == 'VehicleNo') {
      const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
      this.data[data.dataField] = newValue;
    } else if (data.dataField == 'Driver') {
      const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
      this.data[data.dataField] = newValue;
      this.data.DriverMobileNo = value.MobileNo;
      // Added by priya - 31/03/2026 - cn(PRIYA-MAR26-015)
      this.data.DriverLicenseNo = value.LicenseNo || null;
      this.data.DriverDOB = value.DOB || null;
      // End by priya
    } else if (data.dataField == 'LeadTime') {
      this.data[data.dataField] = value;

      const result = new Date(this.data.VehiclePlacementDate);
      result.setDate(result.getDate() + parseInt(value));
      let placementDate = this.dp.transform(this.data.VehiclePlacementDate, 'dd-MMM-yyyy HH:mm');
      this.CalculateDeliveryDate(placementDate, value);
      // this.data.EstimatedDeliveryDate = this.dp.transform(result, 'dd-MMM-yyyy HH:mm');
    } else if (data && data.dataField === 'VehicleType') {
      this.data[data.dataField] = value.value;
    } else if (data.dataField == 'VehiclePlacementDate') {
      this.data[data.dataField] = value;
      let placementDate = this.dp.transform(value, 'dd-MMM-yyyy HH:mm');
      this.CalculateDeliveryDate(placementDate, this.data.LeadTime); // Added by priya - 23/06/2026 - cn(PRIYA-JUN26-007)
    } else {
      this.data[data.dataField] = value;
    }

    if (this.ScreenName && this.ScreenName === 'Dispatch') {
      if (data && data.dataField === 'TransportService') {
        let TS = null;
        if (data.dropdownList && value && value !== undefined) {
          TS = data.dropdownList.find(x => x && x.value === value);
        }
        this.data.DSPTransportService = TS && TS.name ? TS.name : null;

      } else if (data && data.dataField === 'Transporter') {
        if (value) {
          this.data.DSPTransporter = value.ShortCode;
        } else {
          this.data.DSPTransporter = null;
        }
      } else if (data && data.dataField === 'VehicleType') {
        if (value) {
          this.data.DSPVehicleType = value.name;
        } else {
          this.data.DSPVehicleType = null;
        }
      } else if (data.dataField == 'VehicleNo') {
        const newValue = value && typeof value === 'object' && 'value' in value ? value.name : value;
        if (newValue) {
          this.data.DSPVehicleNo = newValue;
        } else {
          this.data.DSPVehicleNo = null;
        }
      } else if (data.dataField == 'Driver') {
        const newValue = value && typeof value === 'object' && 'value' in value ? value.name : value;
        if (newValue) {
          this.data.DSPDriver = newValue;
          this.data.DSPDriverMobileNo = value.MobileNo;
        } else {
          this.data.DSPDriver = null;
          this.data.DSPDriverMobileNo = null;
        }
      } else if (data.dataField == 'DriverMobileNo') {
        if (value) {
          this.data.DSPDriverMobileNo = value;
        } else {
          this.data.DSPDriverMobileNo = null;
        }
      } else if (data.dataField == 'VehiclePlacementDate') {
        if (value) {
          this.data.DSPVehiclePlacementDate = value;
        } else {
          this.data.DSPVehiclePlacementDate = null;
        }
        let placementDate = this.dp.transform(value, 'dd-MMM-yyyy HH:mm');
        // this.CalculateDeliveryDate(placementDate); // Added by priya - 23/06/2026 - cn(PRIYA-JUN26-007)
      } else if (data.dataField == 'EstimatedDeliveryDate') {
        if (value) {
          this.data.DSPEstimatedDeliveryDate = value;
        } else {
          this.data.DSPEstimatedDeliveryDate = null;
        }
      } else if (data.dataField == 'LeadTime') {
        this.data.DSPLeadTime = value;
        const result = new Date(this.data.DSPVehiclePlacementDate);
        result.setDate(result.getDate() + parseInt(value));
        this.data.DSPEstimatedDeliveryDate = this.dp.transform(result, 'dd-MMM-yyyy HH:mm');
      } else {
        this.data[data.dataField] = value;
      }
    }
    console.log('this.data', this.data);
  }

  getDropdownList(value, data) {
    // 
    if (data.dataField === 'TransportService') {
      this.searchStatusOnField(data, true);
      this.orderService.GetTransportServiceList().then(res => {
        this.findObjectOfTheFieldV2(this.TransportService, res);
      }).catch(error => {
        this.searchStatusOnField(data, false);
      })
    }
    if (data.dataField === 'VehicleType') {

      this.searchStatusOnField(data, true);
      this.orderService.GetVehicleTypeselect2(value, 1).then(res => {
        this.findObjectOfTheFieldV2(this.VehicleType, res);
      }).catch(error => {
        this.searchStatusOnField(data, false);
      })
    }
  }

  findObjectOfTheFieldV2(data, dropdownList) {
    data.dropdownList = dropdownList;
    data.isSearch = false;
    if (data.dataField) {
      data.isReadOnly = false
    }

    if (data.dataField === 'VehicleType') {
      console.log('VehicleType dropdown loaded:', dropdownList);
    }
  }

  searchStatusOnField(data, Status) {
    data.isSearch = Status;
  }

  GetTransporterList(value, isScrollDown = false) {
    this.Transporter.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Transporter.dropdownList.length / 20) + 1;
    }
    this.orderService.TransporterSelect2(value, pageNo, this.TenantId).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Transporter.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Transporter.dropdownList);
        this.Transporter = { ...this.Transporter, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Transporter = { ...this.Transporter, dropdownList: [...dropdownList] });
      this.Transporter.isSearch = false;
      this.callTransportersType();
    }).catch(error => {
      this.Transporter.isSearch = false;
    })
  }

  GetVehicleNoList(value, isScrollDown = false) {
    this.VehicleNo.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.VehicleNo.dropdownList.length / 40) + 1;
    }
    this.orderService.GetAssignVehicleVehicleDriverList(value, pageNo, this.CompanyId, this.data.Transporter, this.data.VehicleType).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.VehicleNo.dropdownList.length) {
        dropdownList = dropdownList.concat(this.VehicleNo.dropdownList);
        this.VehicleNo = { ...this.VehicleNo, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.VehicleNo = { ...this.VehicleNo, dropdownList: [...dropdownList] });
      this.VehicleNo.isSearch = false;
    }).catch(error => {
      this.VehicleNo.isSearch = false;
    })
  }

  GetDriverList(value, isScrollDown = false) {
    this.Driver.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Driver.dropdownList.length / 40) + 1;
    }
    this.orderService.GetDriverSelect2(value, pageNo, this.data.Transporter).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Driver.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Driver.dropdownList);
        this.Driver = { ...this.Driver, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Driver = { ...this.Driver, dropdownList: [...dropdownList] });
      this.Driver.isSearch = false;
    }).catch(error => {
      this.Driver.isSearch = false;
    })
  }

  ValidateData() {
    var IsAllDataDone: any = true;
    if (!this.data.TransportService) {
      IsAllDataDone = false;
    }
    if (!this.data.Transporter) {
      IsAllDataDone = false;
    }
    if (!this.data.VehicleType) {
      IsAllDataDone = false;
    }
    if (!this.data.VehicleNo) {
      IsAllDataDone = false;
    }
    if (!this.data.Driver) {
      IsAllDataDone = false;
    }
    if (!this.data.DriverMobileNo) {
      IsAllDataDone = false;
    }
    if (!this.data.EstimatedDeliveryDate) {
      IsAllDataDone = false;
    }
    if (!this.data.VehiclePlacementDate) {
      IsAllDataDone = false;
    }
    if (this.IsSarathiLicenseValidity) {
      if (!this.data.DriverLicenseNo) {
        IsAllDataDone = false;
      }
      if (!this.data.DriverDOB) {
        IsAllDataDone = false;
      }
    }
    if (!IsAllDataDone) {
      var RequiredError = this.translate.instant("DriverDetailsById.RequiredError");
      this.toastr.error(RequiredError, "error");
    }
    return IsAllDataDone;
  }

  OnSaveAssignVehicle() {
    if (this.ScreenName && this.ScreenName === 'Dispatch') {
      if (!this.data.VehicleNo) {
        this.toastr.warning('Please Enter Vehicle No', 'Warning');
        return;
      }
      this.onSave.emit(this.data);
    } else {
      this.isFormSubmit = true;
      if (this.ValidateData()) {
        const branch = (this.selectedBranchCountry || '').toString().trim().toLowerCase();
        const isUlipVerified = (this.ULIPVerification === true);
        // Added by priya - 30/03/2026 - cn(PRIYA-MAR26-015)
        if (this.ULIPVerification === true) {
          if (this.ulipComp) {
            const weightMismatch = this.ulipComp.IsVahanWeightMismatchValidity && this.ulipComp.isWeightMismatch;
            if (this.ulipComp.hasAnyExpired() || weightMismatch) {
              this.toastr.warning("Assignment failed: Invalid vehicle documents or driver's license");
              return;
            }
          }
          // if (this.ulipComp && (this.ulipComp.hasAnyExpired() || this.ulipComp.isWeightMismatch)) {
          //   this.toastr.warning("Assignment failed: Invalid vehicle documents or driver's license");
          //   return;
          // }
          // console.log('issave')
        }

        // Commented by priya - 20/01/2026 - we are verifying ulip onclick button not in the save function - cn(PRIYA-JAN26-013)
        this.onSave.emit(this.data);
        // if(isUlipVerified){
        //   if(branch === 'india'){
        //     this.ValidateBothVehDriver();
        //   }else{
        //     this.onSave.emit(this.data);
        //   }
        // }else{
        //   this.onSave.emit(this.data);
        // }
      }
    }
  }

  // Added and commented by priya - 19/01/2026 - using common function for getting or saving vehicle and driver ulip - cn(PRIYA-JAN26-013)
  ValidateBothVehDriver() {
    var vehicleNo = this.data.VehicleNo;
    var licenseNo = this.data.DriverLicenseNo;
    var dob = this.data.DriverDOB;
    this.Ulip.ValidateVehicleDriverUlip(licenseNo, dob, vehicleNo, this.userId).then(res => {
      if (this.ulipComp) {
        this.ulipComp.reloadData(licenseNo, vehicleNo);
      }
      this.IsVarifiedUlip = true;
    })
      .catch(err => {
        this.IsVarifiedUlip = false
      });
  }

  // ValidateBothVehDriver(){
  //   if (!this.data.VehicleNo) {
  //     this.toastr.warning("Please enter vehicle No. to validate via Ulip!", "warning");
  //   }
  //   if (!this.data.DriverLicenseNo) {
  //       this.toastr.warning("Please enter driver license No.to validate via Ulip!", "warning");
  //   }
  //   if (!this.data.DriverDOB) {
  //     this.toastr.warning("Please enter driver Date Of Birth to validate via Ulip!", "warning");
  //   }

  //   this.vahanData = {};
  //   var vehicleNo = this.data.VehicleNo;
  //   if (vehicleNo != '' && vehicleNo != null) {
  //     this._appService.GetByOneParam("VehicleMaster", "GetVahanData",vehicleNo).subscribe(
  //     (response) => {
  //       this.vahanData = response.vahanData;
  //       if (this.vahanData && Object.keys(this.vahanData).length > 0) {
  //           const currentDate = new Date();
  //           const insuranceDate = this.parseDate(this.vahanData.RcInsuranceUpto);
  //           const fitDate = this.parseDate(this.vahanData.RcFitUpto);
  //           const taxDate = this.parseDate(this.vahanData.RcTaxUpto);

  //         if (
  //           !isNaN(insuranceDate.getTime()) &&
  //           !isNaN(fitDate.getTime()) &&
  //           !isNaN(taxDate.getTime()) &&
  //           insuranceDate > currentDate &&
  //           fitDate > currentDate &&
  //           taxDate > currentDate
  //         ) {
  //           this.isVehValid = true;
  //           this.ValidateDriverViaUlip();
  //           this.saveUlipData(vehicleNo, this.vahanData);
  //         }
  //         else {
  //           this.isVehValid = false;
  //           this.ValidateDriverViaUlip();
  //           this.toastr.warning("The vehicle's insurance, fitness, or tax is not valid.");
  //         }
  //       }
  //       else {
  //         this.isVehValid = false;
  //         this.toastr.warning("No vehicle data found for the provided vehicle No.");
  //         this.ValidateDriverViaUlip();
  //       }
  //     },
  //     (err) => {
  //       this.ValidateDriverViaUlip();
  //       this.toastr.error("An error occured !", "error");
  //     });
  //   }
  // }

  // Added and commented by priya - 19/01/2026 - using common function for getting and saving driver ulip - cn(PRIYA-JAN26-013)
  ValidateDriverViaUlip() {
    var licenseNo = this.data.DriverLicenseNo;
    var dob = this.data.DriverDOB;
    return this.Ulip.ValidateDriverUlip(licenseNo, dob).then(res => {
      this.sarathiData = res.sarathiData;

      if (this.sarathiData && Object.keys(this.sarathiData).length > 0) {
        this.isDriverValid = true;
        return this.Ulip.SaveDriverUlip(licenseNo, dob, this.sarathiData, this.userId).then(() => {
          this.isDriverValid = true;
        }).catch(err => {
          this.isDriverValid = false;
          throw err;
        });
      } else {
        this.isDriverValid = false;
        return Promise.resolve();
      }
    }).catch(err => {
      this.isDriverValid = false;
      return Promise.resolve();
    });
  }

  // ValidateDriverViaUlip() {
  //   this.sarathiData = {};
  //   var licenseNo = this.data.DriverLicenseNo;
  //   var dob = this.data.DriverDOB;
  //   if (dob) {
  //     const [day, monthStr, year] = dob.split('-');
  //     const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

  //     const month = (months.indexOf(monthStr) + 1).toString().padStart(2, '0');
  //     const formatted = `${year}-${month}-${day.padStart(2, '0')}`;

  //     console.log(formatted); // 1987-05-26
  //     dob = formatted;
  //   }
  //   if (licenseNo != '' && dob != '' && licenseNo != null && dob != null) {
  //     this._appService.GetByTwoId("VehicleMaster","GetSarathiData",licenseNo,dob).subscribe(
  //       (response) => {
  //         this.sarathiData = response.sarathiData;
  //         if (this.sarathiData && Object.keys(this.sarathiData).length > 0) {
  //           //this.sarathiData.DlValidity = "2020-08-01T00:00:00"; //to comment
  //           var currentDATE1 = new Date();
  //           var formattedDate1 = currentDATE1.toISOString().split('T')[0] + 'T00:00:00';
  //           if (this.sarathiData.DlValidity > formattedDate1) {
  //             this.isDriverValid = true;
  //             this.validateULIP();
  //             this.saveUlipDataForDriver(licenseNo, dob, this.sarathiData);
  //           }
  //           else {
  //             this.isDriverValid = false;
  //             this.toastr.warning("Driver license is expired.");
  //           }
  //         }
  //         else {
  //           this.toastr.warning("No driver data found for the provided license number and date of birth.");
  //           this.isDriverValid = false;
  //         }
  //       },
  //       (err) => {
  //         this.toastr.error("An error occured !", "error");
  //       }
  //     );
  //   }

  // }

  GetNewVehicle(value, isScrollDown = false) {
    this.VehicleType.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.VehicleType.dropdownList.length / 40) + 1;
    }
    this.orderService.GetVehicleTypeselect2(value, pageNo).then(res => {
      let dropdownList = res.map(item => ({ value: item.value, name: item.name }));
      console.log('dropdownList', dropdownList);
      if (isScrollDown && res.Total > this.VehicleType.dropdownList.length) {
        dropdownList = dropdownList.concat(this.VehicleType.dropdownList);
        this.VehicleType = { ...this.VehicleType, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.VehicleType = { ...this.VehicleType, dropdownList: [...dropdownList] });
      this.VehicleType.isSearch = false;
    }).catch(error => {
      this.VehicleType.isSearch = false;
    })
  }

  callTransportersType() {
    this.TransportersType = this.Transporter.dropdownList.filter((x) => x.id === this.data.Transporter)[0].TransporterType;
    if (this.TransportersType === 'Hired') {
      this.VehicleNo.addTag = true;
      this.Driver.addTag = true;
    } else {
      this.VehicleNo.addTag = false;
      this.Driver.addTag = false;
    }

    console.log('TransportersType inside callTransportersType', this.TransportersType);
  }

  // callTransportersType() {
  // const selected = this.Transporter.dropdownList.find(x => x.id === this.data.Transporter);

  // this.TransportersType = selected.TransporterType || null;
  // if (this.TransportersType === 'Hired') {
  //   this.VehicleNo.addTag = true;
  //   this.Driver.addTag = true;
  // } else {
  //   this.VehicleNo.addTag = false;
  //   this.Driver.addTag = false;
  // }

  //   console.log('TransportersType:', this.TransportersType);
  // }

  //added by fahim 30-12-2025 :)
  ULIPVerification: boolean = false;
  LoadULIPVerification() {
    this._appService.GetById("Common", "GetSystemSettingByName", "ULIPVerification").subscribe((response) => {
      if (response == '1') {
        this.ULIPVerification = true;
        // this.DriverLicenseNo.isRequired=true;
        // this.DriverDOB.isRequired=true;
      } else {
        this.ULIPVerification = false;
      }
      console.log('ULIPVerification>>', this.ULIPVerification);
      console.log('selectedBranchCountry', this.selectedBranchCountry);
    },
      (err) => {
        this.toastr.error("Error occurred while fetching Status data !", "error");
      });
  }
  //End - added by fahim 30-12-2025 :)

  saveUlipDataForDriver(licenseNo, dob, obj) {
    const PostData = {
      Type: 'Driver',
      ReferenceNo: licenseNo,
      ReferenceDate: dob,
      Response: JSON.stringify(obj),
      CreatedBy: this.userId,
    }
    this._appService.Post('VehicleMaster', 'saveUlipData', PostData).subscribe(
      (response) => {
        console.log('saveUlipData:', response);
      },
      (error) => {
        this.toastr.error('Error while saving ULIP data');
      }
    );
  }

  saveUlipData(vehicleNo, obj) {
    const PostData = {
      Type: 'Vehicle',
      ReferenceNo: vehicleNo,
      ReferenceDate: null,
      Response: JSON.stringify(obj),
      CreatedBy: this.userId,
    }
    this._appService.Post('VehicleMaster', 'saveUlipData', PostData).subscribe(
      (response) => {
        console.log('saveUlipData:', response);
      },
      (error) => {
        this.toastr.error('Error while saving ULIP data');
      }
    );
  }

  private parseDate(dateStr: string): Date {
    if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
      const [day, month, year] = dateStr.split('-');
      return new Date(`${year}-${month}-${day}`);
    }
    return new Date(dateStr);
  }

  validateULIP() {
    if (this.isVehValid && this.isDriverValid) {
      this.onSave.emit(this.data);
    }
    // else{
    //   this.toastr.warning("No driver and vehicle data found .");
    //   return;
    // }
  }

  BydeafltFTL() {
    if (this.ScreenName && this.ScreenName === 'Dispatch') {
      let TS = null;
      if (
        this.TransportService &&
        this.TransportService.dropdownList &&
        Array.isArray(this.TransportService.dropdownList)
      ) {
        TS = this.TransportService.dropdownList.find(x => x && x.name === 'FTL') || null;
      }

      this.data = this.data || {};
      this.data.DSPTransportService = TS && TS.name ? TS.name : null;
      this.data.TransportService = TS && TS.value ? TS.value : null;

      this.data.VehiclePlacementDate = this.dp.transform(new Date(), 'dd-MMM-yyyy HH:mm:ss');
      this.data.DSPVehiclePlacementDate = this.dp.transform(new Date(), 'dd-MMM-yyyy HH:mm:ss');
      this.data.LeadTime = 1
      this.data.DSPLeadTime = 1
      this.data.DSPVehicleType = 'NA'
    }
  }

  IsSarathiLicenseValidity: boolean = false;
  CheckSarathiLicenseValidity() {
    this._appService.GetById("Common", "GetSystemSettingByName", "CheckSarathiLicenseValidity").subscribe((response) => {
      if (response == '1') {
        this.IsSarathiLicenseValidity = true;
        this.DriverLicenseNo.isRequired = true;
        this.DriverDOB.isRequired = true;
      } else {
        this.IsSarathiLicenseValidity = false;
        this.DriverLicenseNo.isRequired = false;
        this.DriverDOB.isRequired = false;
      }
      console.log('IsSarathiLicenseValidity>>', this.IsSarathiLicenseValidity);
    },
      (err) => {
        this.toastr.error("Error occurred while fetching Status data !", "error");
      });
  }

  // Added by priya - 23/06/2026 - cn(PRIYA-JUN26-008)
  GetsystemSettingValueForCalculateTime() {
    this._appService.GetById("Common", "GetSystemSettingByName", "IsCalculateTravelTimeByVehicleKm").subscribe(
      (response) => {
        if (response == "1") {
          this.IsCalculateTravelTimeByVehicleKm = true;
        } else {
          this.IsCalculateTravelTimeByVehicleKm = true;
        }
      },
      (err) => {
        this.toastr.error("Error occurred while fetching data !", "error");
      }
    );
  }

  // Added by priya - 23/06/2026 - cn(PRIYA-JUN26-007)
  CalculateDeliveryDate(placedate, LeadTime) {
    let estimatedDate = new Date(placedate);
    let travelDays = 0;
    let travelHours = 0;
    let travelMinutes = 0;

    if (this.bookingData.VehicleTravelTime) {
      const travelTime = this.bookingData.VehicleTravelTime;
      const dayMatch = travelTime.match(/(\d+)\s*days?/i);
      const hourMatch = travelTime.match(/(\d+)\s*hours?/i);
      const minMatch = travelTime.match(/(\d+)\s*mins?/i);

      travelDays = dayMatch ? parseInt(dayMatch[1], 10) : 0;
      travelHours = hourMatch ? parseInt(hourMatch[1], 10) : 0;
      travelMinutes = minMatch ? parseInt(minMatch[1], 10) : 0;

      let calculatedLeadTime = travelDays;
      if (travelHours >= 8) {
        calculatedLeadTime += 1;
      }
      // First load: populate LeadTime from TravelTime
      if (!this.data.LeadTime || this.data.LeadTime == 0) {
        this.data.LeadTime = calculatedLeadTime;
        LeadTime = calculatedLeadTime;
      }

      // Add travel time
      estimatedDate.setMinutes(
        estimatedDate.getMinutes() +
        (travelDays * 24 * 60) +
        (travelHours * 60) +
        travelMinutes
      );
    }

    // Add only extra lead days entered by user
    // const extraLeadDays = Math.max((Number(LeadTime) || 0) - travelDays, 0);
    const baseLeadTime = travelDays + (travelHours >= 8 ? 1 : 0);
    const extraLeadDays = Math.max((Number(LeadTime) || 0) - baseLeadTime, 0);
    estimatedDate.setDate(estimatedDate.getDate() + extraLeadDays);
    this.data.EstimatedDeliveryDate = this.dp.transform(estimatedDate, 'dd-MMM-yyyy HH:mm:ss');
  }
  // End by priya

}
